import { dataAcademicCap } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAcademicCap = /*#__PURE__*/createIcon(dataAcademicCap)
export default IconAcademicCap
